<template>
  <!-- Navbar -->
  <nav
    :style="`background:${backgroundColor}`"
    class="ease-linear transition-all duration-300 w-full bg-abi-darkBlue md:flex hidden md:flex-row md:flex-nowrap md:justify-start items-center p-4 pb-28 z-10"
  >
    <div
      class="w-full mx-auto items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4"
    >
      <!-- Brand -->
      <a
        class="text-white text-sm uppercase hidden lg:inline-block font-semibold"
        href="javascript:void(0)"
      >
        {{
          currentRouteName === "component-edit"
            ? componentName
            : currentRouteName === "component-create"
            ? componentName
            : currentRouteName
        }}
        {{ instanceDescription ? ` - ${instanceDescription}` : "" }}
      </a>
      <!-- User -->
      <div class="flex items-center justify-center mr-4">
        <RegionSelector v-model="currentRegion" />
        <GlobalSearchBar />
        <ul class="flex-col md:flex-row list-none items-center hidden md:flex">
          <user-dropdown />
        </ul>
      </div>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import * as Helpers from "@/helpers";
import UserDropdown from "@/components/Shared/Dropdowns/UserDropdown.vue";
import GlobalSearchBar from "@/components/Shared/Input/GlobalSearchBar.vue";
import RegionSelector from "@/components/Shared/Input/RegionSelector.vue";

export default {
  components: {
    UserDropdown,
    GlobalSearchBar,
    RegionSelector
  },
  data() {
    return {
      backgroundColor: "#505f6b",
      region: "au"
    };
  },
  mounted() {
    this.checkBgColor();
  },
  watch: {
    currentRouteName() {
      this.checkBgColor();
    },
    getRegion() {
      this.checkBgColor();
    }
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    componentName() {
      if (
        this.currentRouteName === "component-edit" ||
        this.currentRouteName === "component-create"
      ) {
        let componentId = this.$route.fullPath.split("/").slice(-2)[0];
        return this.getAllComponent
          .find((item) => {
            return item.id === componentId;
          })
          ?.name.replaceAll("_", " ");
      } else {
        return "";
      }
    },
    instanceDescription() {
      if (
        this.currentRouteName === "component-edit" ||
        this.currentRouteName === "component-create"
      ) {
        let instanceId = this.$route.fullPath.split("/").slice(-2)[1];
        return this.getInstanceInfo.find((item) => {
          return item.id === instanceId;
        })?.description;
      } else {
        return "";
      }
    },
    currentRegion: {
      get: function () {
        return this.getRegion;
      },
      set: function (val) {
        this.$store.dispatch(Actions.SET_REGION, val).then(() => {
          this.$router.push("/");
          localStorage.setItem("cm_region", val);
          Helpers.loadAllRelatedData(this, {
            hardRefresh: false,
            region: this.getRegion
          });
        });
      }
    },
    ...mapGetters(["getRegion", "getInstanceInfo", "getAllComponent"])
  },
  methods: {
    checkBgColor() {
      if (this.getRegion === "nz") {
        this.backgroundColor = "#3e3e3e";
      } else if (this.getRegion === "au") {
        this.backgroundColor = "#68be8c";
      } else if (this.getRegion === "uk") {
        this.backgroundColor = "#4b6ca9";
      }
    }
  }
};
</script>
